import { createAction } from 'redux-actions';
export const SET_SELECTED_FARE_GROUP = 'SET_SELECTED_FARE_GROUP';
export const setSelectedFareGroup = createAction(SET_SELECTED_FARE_GROUP);
